module.exports = __webpack_public_path__ + "img/NO816793432.fb8df2a6.png";